export const formatDeviceTimestamp = (ms: number | null | undefined): string => {
  if (ms == null || ms <= 0) return "—";
  try {
    return new Intl.DateTimeFormat(undefined, { dateStyle: "medium", timeStyle: "short" }).format(
      new Date(ms)
    );
  } catch {
    return "—";
  }
};

const TYPE_LABELS: Record<string, string> = {
  tablet: "Tablet",
  table: "Table",
  desktop: "Desktop",
  laptop: "Laptop",
  mobile: "Mobile",
  server: "Server",
  iot: "IoT",
};

export const formatDeviceTypeLabel = (deviceType: string): string => TYPE_LABELS[deviceType] ?? deviceType;
